import { CalendarIcon } from "@heroicons/react/outline";
import { useField } from "formik";
import React from "react";
import DatePicker from "react-datepicker";
import { FieldFeedbackLabel } from "./FieldFeedbackLabel";

export function DatePickerField({
  label,
  withFeedbackLabel = true,
  type = "text",
  customFeedbackLabel,
  ...props
}) {
  const [field, meta] = useField(props);
  const { touched, error } = meta;
  const { disabled } = props;
  field.value = new Date(field.value);
  // console.log(touched, error);

  function getDivCSSClasses(touched, errors, disabled) {
    const classes =
      disabled === true
        ? [
            "flex items-center w-full h-11 pl-3 pr-6 mt-2 text-sm font-regular text-gray-600 border rounded-md border-gray-300 focus:outline-none focus:border-primary bg-gray-100 text-opacity-60 border-opacity-70 bg-opacity-70"
          ]
        : [
            "flex items-center w-full h-11 pl-3 pr-6 mt-2 text-sm font-regular text-gray-600 border rounded-md border-gray-300 hover:bg-gray-50 focus:outline-none focus:border-primary"
          ];

    if (touched && errors) {
      classes.push("border-2 border-red-500");
    }

    if (touched === true && errors === undefined) {
      classes.push("border-2 border-green-500");
    }

    return classes.join(" ");
  }

  function getFieldCSSClasses(touched, errors, disabled) {
    const classes = [
      "w-full border-none hover:bg-gray-50 text-gray-600 focus:outline-none focus:ring-0 disabled:bg-gray-100 disabled:text-gray-600 disabled:text-opacity-60 disabled:border-opacity-70 disabled:bg-opacity-70"
    ];

    return classes.join(" ");
  }

  function getIconCSSClasses(touched, errors, disabled) {
    const classes = ["w-5 h-5 text-gray-600"];

    if (touched && errors) {
      classes.push("text-red-500");
    }

    if (touched === true && errors === undefined) {
      classes.push("text-green-500");
    }

    if (disabled === true) {
      classes.push("text-gray-600 text-opacity-60");
    }

    return classes.join(" ");
  }

  return (
    <>
      <label className="text-gray-500 text-sm font-semibold">{label}</label>
      <div className={getDivCSSClasses(touched, error, disabled)}>
        <CalendarIcon className={getIconCSSClasses(touched, error, disabled)} />
        <DatePicker
          className={getFieldCSSClasses(touched, error, disabled)}
          {...field}
          {...props}
        />
      </div>
      {withFeedbackLabel && error && (
        <>
          <FieldFeedbackLabel
            error={error}
            touched={touched}
            label={label}
            type={type}
            customFeedbackLabel={customFeedbackLabel}
          />
        </>
      )}
    </>
  );
}

export function DatePickerFieldRange({
  label,
  withFeedbackLabel = true,
  type = "text",
  customFeedbackLabel,
  ...props
}) {
  const { startDate, endDate } = props;
  const { disabled } = props;

  function getDivCSSClasses(touched, errors, disabled) {
    const classes =
      disabled === true
        ? [
            "flex items-center w-full h-11 pl-3 pr-6 mt-2 text-sm font-regular text-gray-600 border rounded-md border-gray-300 focus:outline-none focus:border-primary bg-gray-100 text-opacity-60 border-opacity-70 bg-opacity-70"
          ]
        : [
            "flex items-center w-full h-11 pl-3 pr-6 mt-2 text-sm font-regular text-gray-600 border rounded-md border-gray-300 hover:bg-gray-50 focus:outline-none focus:border-primary"
          ];

    if (touched && errors) {
      classes.push("border-2 border-red-500");
    }

    if (touched === true && errors === undefined) {
      classes.push("border-2 border-green-500");
    }

    return classes.join(" ");
  }

  function getFieldCSSClasses(touched, errors, disabled) {
    const classes = [
      "w-full border-none hover:bg-gray-50 text-gray-600 focus:outline-none focus:ring-0 disabled:bg-gray-100 disabled:text-gray-600 disabled:text-opacity-60 disabled:border-opacity-70 disabled:bg-opacity-70"
    ];

    return classes.join(" ");
  }

  function getIconCSSClasses(touched, errors, disabled) {
    const classes = ["w-5 h-5 text-gray-600"];

    if (touched && errors) {
      classes.push("text-red-500");
    }

    if (touched === true && errors === undefined) {
      classes.push("text-green-500");
    }

    if (disabled === true) {
      classes.push("text-gray-600 text-opacity-60");
    }

    return classes.join(" ");
  }

  return (
    <>
      <label className="text-gray-500 text-sm font-semibold">{label}</label>
      <div className={getDivCSSClasses(null, null, disabled)}>
        <CalendarIcon className={getIconCSSClasses(null, null, disabled)} />
        <DatePicker
          className={getFieldCSSClasses(null, null, disabled)}
          {...props}
        />
      </div>
    </>
  );
}
